import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import {
  Actividad,
  CorreoElectronico,
  createCorreoElectronico
} from '@rpe/registro-personas-empresas-lib';
import { Observable, Subscription } from 'rxjs';
import { DireccionesGeograficasFormComponent } from '../../ubicaciones/direcciones-geograficas/direcciones-geograficas-form/direcciones-geograficas-form.component';
import { selectActividadFromCurrentEmpresaByTipoActividad } from '../entity-actividades/entity-actividades.selectors';
import { State } from '../../vista-usuario/vista-usuario.state';
import {
  createEmptySitioProcesamiento,
  createSitioProcesamiento,
  ProcesamientoMaquinariaEspecies,
  SitioProcesamiento,
  SitioProcesamientoFormInput
} from '../entity-sitios-procesamiento/sitios-procesamiento.model';
import { RegistroActividadSitioProcesamientoEquipamientoFormComponent } from './registro-actividad-sitio-procesamiento-equipamiento-form/registro-actividad-sitio-procesamiento-equipamiento-form.component';
import { selectCurrentEmpresa } from '../../empresas/entity-mis-empresas/entity-current-empresa.selectors';
import { DatosContactoFormComponent } from '../../contactos/datos-contacto/datos-contacto-form/datos-contacto-form.component';
import {
  createDatosContacto,
  DatosContacto
} from '../../contactos/datos-contacto/datos-contacto.model';
import { DireccionGeografica } from '../../ubicaciones/direcciones-geograficas/direcciones-geografica.model';

@Component({
  selector: 'rpe-registro-actividad-sitio-procesamiento-form',
  templateUrl: './registro-actividad-sitio-procesamiento-form.component.html',
  styleUrls: ['./registro-actividad-sitio-procesamiento-form.component.scss']
})
export class RegistroActividadSitioProcesamientoFormComponent
  implements OnInit, OnDestroy, AfterViewInit {
  @Input() index = 0;

  @Input() set formInput(sp: SitioProcesamiento) {
    if (sp && this.primeraVez) {
      this._sitioProcesamiento = sp;
    }

    if (!sp && this.primeraVez) {
      this._sitioProcesamiento = createEmptySitioProcesamiento();
    }

    if (this.primeraVez) {
      this.setForm();
    }

    this.primeraVez = false;
  }

  get formInput(): SitioProcesamiento {
    return this._sitioProcesamiento;
  }

  @Output() newSitioProcesamiento = new EventEmitter<boolean>();
  @Output() formStatusChanges = new EventEmitter<string>();
  @Output() formValueChanges = new EventEmitter<SitioProcesamiento>();

  // Direccion geografica
  @ViewChild(DireccionesGeograficasFormComponent)
  direccionGeograficaForm: DireccionesGeograficasFormComponent;

  direccionGeograficaFormInput: DireccionGeografica = null;
  direccionGeografica: DireccionGeografica;
  direccionGeograficaValid: boolean = false;

  // Datos de contacto
  @ViewChild(DatosContactoFormComponent, { static: true })
  datosContactoForm: DatosContactoFormComponent;

  datosContactoFormInput: DatosContacto = null;
  datosContacto: DatosContacto;
  datosContactoStatus: string;

  // Equipamiento
  @ViewChild(RegistroActividadSitioProcesamientoEquipamientoFormComponent)
  equipamientoForm: RegistroActividadSitioProcesamientoEquipamientoFormComponent;

  // Falta el viewChild
  equipamientoFormInput: ProcesamientoMaquinariaEspecies = null;
  equipamientoSitioProcesamiento: ProcesamientoMaquinariaEspecies = {
    equipamientoProcesamiento: null
  };
  equipamientoValid: boolean = false;

  registroActividadSitioProcesamientoFormGroup: FormGroup = this.fb.group({
    id: [null, []],
    nombre: [null, [Validators.required]],
    entidad_productiva_id: [null, [Validators.required]],
    brinda_servicios_terceros: [null, [Validators.required]]
    // direccion_geografica: this.direccionGeograficaForm.createGroup()
  });
  _sitiosProcesamientoFormInput: SitioProcesamientoFormInput;
  _sitioProcesamiento: SitioProcesamiento;
  actividad$: Observable<Actividad>;
  subscription: Subscription;
  primeraVez: boolean = true;
  brindaServiciosTercero: boolean = null;

  isLoaded = false;

  constructor(private fb: FormBuilder, private store: Store<State>) { }

  ngOnInit(): void {
    this.actividad$ = this.store.select(
      selectActividadFromCurrentEmpresaByTipoActividad(7)
    );

    this.subscription = this.store
      .select(selectCurrentEmpresa)
      .subscribe((e) => {
        if (!this._sitioProcesamiento.entidad_productiva_id) {
          this._sitioProcesamiento.entidad_productiva_id = e.id;
          this.registroActividadSitioProcesamientoFormGroup.patchValue({
            entidad_productiva_id:
              this._sitioProcesamiento.entidad_productiva_id
          });
        }
      });

    // emit events
    this.registroActividadSitioProcesamientoFormGroup.valueChanges.subscribe(
      (_) => {
        this.emitirFormValues();
      }
    );

    this.registroActividadSitioProcesamientoFormGroup.statusChanges.subscribe(
      (f) => {
        this.emitirFormStatus();
      }
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  ngAfterViewInit() {
    this.isLoaded = true;
  }

  // Datos contacto
  datosContactoChange(dc: DatosContacto) {
    this.datosContacto = dc;
    this.emitirFormValues();
  }

  datosContactoStatusChange(s: string) {
    this.datosContactoStatus = s;
    this.emitirFormStatus();
  }

  // Direccion Geografica
  direccionGeograficaChange(dg: any) {
    this.direccionGeografica = dg;
    this.emitirFormValues();
  }

  direccionGeograficaStatusChange(s: any) {
    this.direccionGeograficaValid = s === 'VALID';
    this.emitirFormStatus();
  }

  // Equipamiento
  equipamientoChange(el: ProcesamientoMaquinariaEspecies) {
    this.equipamientoSitioProcesamiento = el;
    this.emitirFormValues();
  }

  equipamientoStatusChange(f: string) {
    this.equipamientoValid = f === 'VALID';
    this.emitirFormStatus();
  }

  checkChildrens() {
    this.direccionGeograficaForm?.checkErrors();
    this.datosContactoForm.checkErrors();
    this.equipamientoForm.checkErrors();
  }

  onChangeServiciosTerceros(event: any) {
    this.registroActividadSitioProcesamientoFormGroup.patchValue({
      brinda_servicios_terceros: event.value
    });
  }

  creoSitioProcesamiento(): SitioProcesamiento {
    // agrego correos
    let correos: CorreoElectronico[] = [];
    if (this.datosContacto?.correos_electronico) {
      this.datosContacto.correos_electronico.forEach((c: CorreoElectronico) => {
        correos.push(
          createCorreoElectronico({
            id: c.id,
            direccion: c.direccion,
            tipo_correo_id: 1
          })
        );
      });
    } else {
      correos = null;
    }
    const l = createSitioProcesamiento({
      ...this.registroActividadSitioProcesamientoFormGroup.value,
      equipamientos:
        this.equipamientoSitioProcesamiento.equipamientoProcesamiento,
      correos_electronico: correos,
      entidad_productiva_id: this._sitioProcesamiento.entidad_productiva_id,
      telefonos: this.datosContacto?.telefonos,
      direccion_geografica: this.direccionGeografica
    });
    return l;
  }

  emitirFormStatus() {
    let status = 'INVALID';
    if (
      this.registroActividadSitioProcesamientoFormGroup.valid &&
      this.direccionGeograficaValid &&
      this.datosContactoStatus == 'VALID' &&
      this.equipamientoValid
    ) {
      status = 'VALID';
    }
    this.formStatusChanges.emit(status);
  }

  emitirFormValues() {
    const l = this.creoSitioProcesamiento();

    this.formValueChanges.emit(l);
  }

  agregarNuevoSitioProcesamiento() {
    this.newSitioProcesamiento.emit(true);
  }

  eliminarSitioProcesamiento() {
    this.newSitioProcesamiento.emit(false);
  }

  checkErrors() {
    this.registroActividadSitioProcesamientoFormGroup.markAllAsTouched();
    this.checkChildrens();
  }

  setBrindaServiciosTerceros(brinda: boolean) {
    if (brinda != null) {
      this.brindaServiciosTercero = brinda;
    }
  }

  setForm() {
    this.registroActividadSitioProcesamientoFormGroup.patchValue(
      {
        id: this._sitioProcesamiento.id,
        nombre: this._sitioProcesamiento.nombre,
        entidad_productiva_id: this._sitioProcesamiento.entidad_productiva_id,
        brinda_servicios_terceros:
          this._sitioProcesamiento.brinda_servicios_terceros
      },
      { emitEvent: false }
    );
    this.setBrindaServiciosTerceros(
      this._sitioProcesamiento.brinda_servicios_terceros
    );
    this.direccionGeografica = {
      ...this._sitioProcesamiento.direccion_geografica
    };
    this.direccionGeograficaFormInput = this.direccionGeografica;
    this.datosContacto = createDatosContacto({
      telefonos: this._sitioProcesamiento.telefonos,
      correos_electronico: this._sitioProcesamiento.correos_electronico
    });
    this.datosContactoFormInput = this.datosContacto;
    this.equipamientoFormInput = {
      equipamientoProcesamiento: this._sitioProcesamiento.equipamientos,
    };
  }
}
